import { createMemoryHistory } from "history";

export default createMemoryHistory({
  initialEntries: ["/signin", "/offices", "/licenses"],
  initialIndex: 0
});
